export enum ResponseType {
  JSON = 'json',
  ArrayBuffer = 'arraybuffer'
}
